import React, { useRef } from 'react'
import { motion, useInView } from "framer-motion"

import { Container } from '../../Container'
import ContentfulLongText from '../../ContentfulLongText'

import './image-text-blend.css'

export const ImageTextBlend = ({ heroContent, pageHeroTitle }) => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });

    return (
        <div ref={ref} className='cover pages-hero pages-hero--customized image-text-blend' style={{ 
            backgroundImage: `url(${heroContent.backgroundMedia.gatsbyImageData.images.fallback.src})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat'
        }}>
            <Container>
                <div className='grid col-5-6 col-1-md gap-15-md gap-49'>
                    <div className='relative text-white cover image-text-overlay overlay' style={{ 
                        backgroundImage: `url(${heroContent.image})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover'
                     }}>
                        <div className='absolute bottom-0 z-2 text-overlay'>
                            <motion.h3 className='mt-0 mb-0' initial={{ opacity: 0, x: -100 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 1 }}>{heroContent.overlayTitle}</motion.h3>
                            <div className='grid col-4 col-1-md gap-15 lists'>
                                {heroContent.lists.map((item, index) => (
                                    <motion.div key={index} initial={{ opacity: 0, x: -100 * index }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 1 * index }}>
                                        <h4 className="uppercase weight--semibold">{item.title}</h4>
                                        <ContentfulLongText longTextContent={item.description.description}/>
                                    </motion.div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <motion.div initial={{ opacity: 0, x: 100 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 1 }} className='content'>
                        <h1 className='mt-0'><span>{pageHeroTitle}</span></h1>
                        <ContentfulLongText longTextContent={heroContent.content.content} />
                    </motion.div>
                </div>
            </Container>
        </div>
    )
}